import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as PlusIconSvg } from '../../assets/plus-icon.svg';

export const PlusIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={PlusIconSvg} {...props} />;
};
